(function() {
  function parseMatches(value) {
    return String(value || '')
      .split(/[;,\n]+/)
      .map(function(item) {
        return item.trim().toLowerCase();
      })
      .filter(function(item) {
        return item.length > 0;
      })
      .filter(function(item, index, items) {
        return items.indexOf(item) === index;
      })
      .sort();
  }

  if (!customElements.get('wellness-meal')) {
    class WellnessMeal extends HTMLElement {
      constructor() {
        super();
        this.initialized = false;
        this.productButtons = [];
        this.userButtons = [];
        this.mealBlocks = [];
        this.selectedProducts = [];
        this.selectedUser = '';
        this.onProductClick = this.onProductClick.bind(this);
        this.onUserClick = this.onUserClick.bind(this);
      }

      connectedCallback() {
        if (window.elToObserver) {
          window.elToObserver(this, () => this.init());
        } else {
          this.init();
        }
      }

      disconnectedCallback() {
        this.productButtons.forEach((button) => {
          button.removeEventListener('click', this.onProductClick);
        });
        this.userButtons.forEach((button) => {
          button.removeEventListener('click', this.onUserClick);
        });
        this.initialized = false;
      }

      init() {
        if (this.initialized) {
          return;
        }

        this.initialized = true;
        this.productButtons = Array.from(this.querySelectorAll('[data-wm-product]'));
        this.userButtons = Array.from(this.querySelectorAll('[data-wm-user]'));
        this.mealBlocks = Array.from(this.querySelectorAll('[data-wm-meal]'));

        this.productButtons.forEach((button) => {
          button.addEventListener('click', this.onProductClick);
        });
        this.userButtons.forEach((button) => {
          button.addEventListener('click', this.onUserClick);
        });

        this.selectedProducts = [];
        this.selectedUser = '';
        this.updateState();
      }

      onProductClick(event) {
        const product = event.currentTarget.dataset.wmProduct || '';

        if (product === 'none') {
          this.selectedProducts = ['none'];
        } else if (this.selectedProducts.includes(product)) {
          this.selectedProducts = this.selectedProducts.filter((item) => item !== product);
        } else {
          this.selectedProducts = [
            ...this.selectedProducts.filter((item) => item !== 'none'),
            product
          ];
        }

        this.updateState();
      }

      onUserClick(event) {
        this.selectedUser = event.currentTarget.dataset.wmUser || '';
        this.updateState();
      }

      updateState() {
        this.productButtons.forEach((button) => {
          const isActive = this.selectedProducts.includes(button.dataset.wmProduct);
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        this.userButtons.forEach((button) => {
          const isActive = button.dataset.wmUser === this.selectedUser;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        const selectedProducts = this.selectedProducts.filter((product) => product !== 'none');
        const selectedPairs = selectedProducts
          .map((product) => `${product}-${this.selectedUser}`.toLowerCase())
          .sort();
        const selectedPairKey = selectedPairs.join('|');
        const hasSelection = selectedProducts.length > 0 && Boolean(this.selectedUser);

        const isConfiguredMatch = (matches) => {
          if (!matches.length || !hasSelection) {
            return false;
          }

          // A single product can match any pair listed in show_meal.
          if (selectedPairs.length === 1) {
            return matches.includes(selectedPairKey);
          }

          // Multiple products must match the complete pair list.
          return matches.join('|') === selectedPairKey;
        };

        const hasConfiguredMatch = this.mealBlocks.some((meal) => {
          return isConfiguredMatch(parseMatches(meal.dataset.wmMeal));
        });
        let hasMatch = false;

        this.mealBlocks.forEach((meal) => {
          const matches = parseMatches(meal.dataset.wmMeal);
          const isActive = hasSelection && (
            matches.length
              ? isConfiguredMatch(matches)
              : !hasConfiguredMatch
          );

          meal.classList.toggle('is-active', isActive);
          meal.hidden = !isActive;
          if (isActive) {
            hasMatch = true;
          }
        });

        this.classList.toggle('has-no-match', !hasMatch);
      }
    }

    customElements.define('wellness-meal', WellnessMeal);
  }
})();
